export default __webpack_public_path__ + "static/media/blob1.4890eadc.svg";